// extracted by mini-css-extract-plugin
module.exports = {"ReCaptcha":"ReCaptcha_ReCaptcha__3yE-Q"};